import Common from './functions.js'

const domainOption = {
  'www.xbjy123.com': {
    code: 'XiaoBai',
    company: '山东小白教育科技有限公司',
    company_short: '小白教育',
    address: '山东省济南市历城区中物科创中心23号楼1615',
    name: '小白云课堂',
    logo: Common.getResourceUrl('logo2.png'),
    beian: '鲁ICP备20006512号-20',
  },
  'pc.wenqing123.com': {
    code: 'XingHui',
    company: '星绘（济南）教育科技有限公司',
    company_short: '星绘教育',
    address: '山东省济南市历城区中物科创中心23号楼1615',
    name: '星绘插画',
    logo: Common.getResourceUrl('xh_logo.png'),
    beian: '鲁ICP备2022028397号-1',
  },
}
const domain =
  domainOption[location.hostname] || domainOption['pc.wenqing123.com']

export default domain
